// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1173 ? "detail-view" : chunkId) + "." + {"1173":"50cfd24e","9361":"b147d14d"}[chunkId] + ".css";
};